import useNotificationService from '@contexts/useNotificationService';
import { useAppState, useAuthStore } from '@sunrise-ui/primitives';
import { useQueryClient } from '@tanstack/react-query';
import { useEffect } from 'react';

export default function useBackgroundManager() {
  const { appState } = useAppState();
  const { authToken } = useAuthStore();
  const { notificationService } = useNotificationService();
  const queryClient = useQueryClient();

  useEffect(() => {
    if (appState === 'background') {
      notificationService?.closeSocket();
    } else if (appState === 'active' && authToken) {
      void queryClient.invalidateQueries();
      void notificationService?.openSocket(authToken);
    }
  }, [appState, authToken]);
}
